<template>
  <div :class="userStore.borderClass">
    <!-- <div>
      <h6>modalTheme: {{ modalTheme }}</h6>
            <h6>Full Name: {{ user.fullName }}</h6>
      <h6>Name : {{ user.name }}</h6>
    </div> -->
    <div class="container mt-0" style="padding: 0px" :class="modalTheme">
      <b-card title="EMR Credentials Form" class="p-0" :class="modalTheme">
        <b-form @submit.prevent="onSubmit" @reset.prevent="onReset" size="sm">
          <!-- UserName Input -->
          <b-form-group label="UserName" label-for="first-name-input" class="mb-3">
            <b-form-input id="user-name-input" size="sm" v-model="form.userName" placeholder="Enter your User Password" :class="[modalTheme, { 'is-invalid': !form.userPassword }]"></b-form-input>
            <!-- <b-form-input size="sm" id="first-name-input" v-model="form.userName" placeholder="Enter your User  name" :class="[modalTheme, { 'is-invalid': !form.userName }]"></b-form-input> -->
            <div v-if="!form.userName" class="invalid-feedback">UserName is required</div>
          </b-form-group>

          <b-form-group label="UserPassword" label-for="last-name-input" class="mb-3">
            <b-input-group>
              <b-form-input
                id="last-name-input"
                size="sm"
                :type="showPassword ? 'text' : 'password'"
                v-model="form.userPassword"
                placeholder="Enter your User Password"
                :class="[modalTheme, { 'is-invalid': !form.userPassword }]"
              ></b-form-input>
              <b-input-group-append>
                <b-button :class="modalTheme" size="sm" variant="outline-secondary" @click="showPassword = !showPassword" aria-label="Toggle password visibility">
                  <font-awesome-icon :icon="showPassword ? 'eye-slash' : 'eye'" />
                </b-button>
              </b-input-group-append>
            </b-input-group>
            <b-form-text id="password-help-block"> Your password must be 8-20 characters long, contain letters and numbers, and must not contain spaces, special characters, or emoji. </b-form-text>
            <div v-if="!form.userPassword" class="invalid-feedback">UserPassword is required</div>
          </b-form-group>

          <!-- & Submit and Reset Buttons -->
          <div class="d-flex justify-content-end">
            <!-- <span style="color: red; white-space: nowrap; font-size: 8pt; text-align: left">Example User Form:</span> -->
            <b-button :class="modalTheme" size="sm" type="reset" variant="outline-secondary" class="mr-2">Cancel</b-button>
            <b-button :class="modalTheme" size="sm" type="submit" variant="primary" :disabled="!form.userName || !form.userPassword">Submit</b-button>
          </div>
        </b-form>
      </b-card>
    </div>
  </div>
</template>
<script setup>
import { ref, onMounted, computed } from "vue";

// * STOREs
import { useStoreUser } from "@/stores/userStore";
const userStore = useStoreUser();

// * EMITTER
const emit = defineEmits(["userProfileLogin"]);

import { toast } from "vue3-toastify";

const showPassword = ref(false);

const form = ref({
  userName: "",
  userPassword: "",
});
function onSubmit() {
  if (!form.value.userName || !form.value.userPassword) {
    toast.error("Please fill out all required fields.");
    return;
  }
  // alert(`Submitted: ${form.value.userName} ${form.value.userPassword}`);

  emit("userProfileLogin", { ...form.value }); // Emit form data as props
}
function onReset() {
  form.value.userName = props.user.userName || "";
  form.value.userPassword = props.user.userPassword || "";
}

// function createForm() {
// 	return {
// 		userName: '',
// 		userPassword: '',
// 		date: moment(Date.now()).format('YYYY-MM-DD'),
// 	}
// }
// & PROPS
const props = defineProps({
  user: {
    Type: Object,
    Default: () => {},
  },
});

const modalTheme = computed(() => userStore.bModalTheme);

onMounted(() => {
  // console.log("onMounted() :       UP Login  >>>>");
  // console.log(' prop   user ')
  // console.log("props : ");
  // console.log(props);
  // console.log(props.user);
  // * Initialize form with props.user values on mount
  form.value.userName = props.user.userName || "";
  form.value.userPassword = props.user.userPassword || "";
});
</script>
<style lang="scss" scoped>
.create-userprofile-form {
  text-align: initial; // need this because the dx-toolbar text-align: center was causing problems with the labels
  background-color: #3164c4; // #6e796f;
  color: #eef8ef;
  padding-left: 0px;
  padding-right: 0px;
  padding: 6px;
  padding-bottom: 10px;
  border-radius: 5px;
}
.dx-code-description {
  display: inline-block;
  width: 100%;
  overflow-x: auto;
}
.selected-records-grid {
  max-height: 200px;
}
.btn-primary-green {
  border: none;
  text-decoration: none;
  color: #fcfefc;
  background-color: #b0c1b2;
}
.btn-primary-green:hover {
  background-color: #caeacd;
  color: #123486;
  border-radius: 0px 0px 0px 0px;
}
.btn-sm,
.btn-group-sm > .btn {
  padding: 0.25rem 0.5rem;
  font-size: 0.75rem;
  line-height: 1;
  border-radius: 0.2rem;
  background: #eef8ef;
}
.btn-primary-green:focus,
.btn-primary-green.focus {
  box-shadow: 1px 0px 0px 0px #b0c1b2 inset;
  color: #123486;
  background-color: #a5dbaa;
  font-weight: bolder;
}
.btn-primary-green:disabled,
.btn-primary-green.disabled {
  color: #eef8ef;
  background-color: #a62631;
  border-color: #d8d514;
}
.btn-sm,
:disabled,
.btn-sm,
.disabled {
  color: #eef8ef;
  background-color: #2646a6;
  border-color: #d8d514;
}
.invalid-feedback {
  display: none;
  width: 100%;
  margin-top: 0.25rem;
  font-size: 80%;
  //  color: #ffea00;
}
</style>
